import React, { Component } from "react";

class TableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);
    if (Array.isArray(column.path)) {
      let output = "";
      column.path.forEach((element) => {
        output = output.concat(" ").concat(item[element]);
      });
      return output;
    }
    return item[column.path];
  };

  render() {
    const { data, columns } = this.props;

    return (
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr key={"data_" + index}>
              {columns.map((column, index) => (
                <td key={"columns_" + index}>
                  {this.renderCell(item, column)}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
    );
  }
}

export default TableBody;
